import { locale, t } from '@/shared/i18n';

/** Сегодня в формате YYYY-MM-DD по локальному времени. */
export function todayISO(): string {
  const d = new Date();

  return `${String(d.getFullYear())}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

function parseISO(value: string): Date {
  const [y, m, d] = value.split('-').map(Number);

  return new Date(y ?? 1970, (m ?? 1) - 1, d ?? 1);
}

/** Дата коротко: «12 сен», чужой год — «12 сен 2025». */
export function describeDate(value: string): string {
  const date = parseISO(value);
  const sameYear = date.getFullYear() === new Date().getFullYear();

  return date.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'short',
    ...(sameYear ? {} : { year: 'numeric' }),
  });
}

/**
 * Время события словами: «только что», «5 мин назад», «2 ч назад»,
 * «вчера, 14:02», дальше — дата. Для журнала действий и ленты команды.
 */
export function describeWhen(iso: string): string {
  const date = new Date(iso);
  const diff = Date.now() - date.getTime();
  const minutes = Math.round(diff / 60000);

  if (minutes < 1) {
    return t.time.justNow;
  }

  if (minutes < 60) {
    return t.time.minutesAgo(minutes);
  }

  const hours = Math.round(minutes / 60);

  if (hours < 24 && date.getDate() === new Date().getDate()) {
    return t.time.hoursAgo(hours);
  }

  const time = date.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
  const yesterday = new Date();

  yesterday.setDate(yesterday.getDate() - 1);

  if (date.toDateString() === yesterday.toDateString()) {
    return `${t.time.yesterday}, ${time}`;
  }

  const sameYear = date.getFullYear() === new Date().getFullYear();

  return `${date.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'short',
    ...(sameYear ? {} : { year: 'numeric' }),
  })}, ${time}`;
}
